import React from 'react';

import './index.scss';
import { WpIcon } from 'Wpds/components/icon';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

type Props = {
  hide: boolean;
};

export default function ImagePlaceholder({ hide }: Props) {
  const { tr } = useTranslation();

  return (
    <div
      className={`d-flex bg-white flex-column rounded-lg justify-content-start align-items-center position-absolute w-100 h-50 search-module-image-placeholder pt-4 ${
        hide && 'search-module-image-placeholder-hide'
      }`}
    >
      <div className="search-module-image-placeholder-circle">
        <span className="search-module-image-placeholder-icon">
          <WpIcon name="search" size="lg" />
        </span>
      </div>
      <p className="font-weight-bold mt-4 search-module-image-placeholder-text">
        {tr('perform.search.placeholder.start_typing')}
      </p>
    </div>
  );
}
